import { render, staticRenderFns } from "./personal-info.vue?vue&type=template&id=e49b5bc2&scoped=true&"
import script from "./personal-info.vue?vue&type=script&lang=js&"
export * from "./personal-info.vue?vue&type=script&lang=js&"
import style0 from "./personal-info.vue?vue&type=style&index=0&id=e49b5bc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49b5bc2",
  null
  
)

export default component.exports